export enum SignUpSourceEnum {
    InvitedByUser = 90,
    OrganicSignUp = 91,
    SMLInvited = 92,
    DonorInvitedByCommunity = 93,
    ShopifyPurchase = 94
}